<template>
    <div>
        <Navbar/>
<!--        <div class="aboutContent">-->
<!--            <div class="AboutImgDisplayNone">-->
<!--                <img src="@/assets/images/landing/AboutsImg.png">-->
<!--            </div>-->
<!--        </div>-->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <article align="justify" class="content">
                            <div class="content__header">
                                <div class="txt-title-ap"><strong>{{ $t('aboutProject') }}</strong></div>
                                <h3>{{$t('ap_title1')}}</h3>
                            </div>
                            <div v-html="$t('ap_txt1')"/>
                            <div v-html="$t('ap_txt2')"/>
                            <div v-html="$t('ap_txt3')"/>
                            <div v-html="$t('ap_txt4')"/>
                            <div v-html="$t('ap_txt5')"/>
                            <div v-html="$t('ap_txt6')"/>
                            <div v-html="$t('ap_txt7')"/>
                            <div v-html="$t('ap_txt8')"/>
                            <div v-html="$t('ap_txt9')"/>
                        </article>
                    </div>
                </div>
            </div>
        </section>
        <!--            <div class="Img">-->
        <!--                <img src="@/assets/images/landing/AboutsImg.png">-->
        <!--            </div>-->
        <!--            <img class="aboutComponentsCopyBookImg" src="@/assets/images/landing/aboutComponentsCopyBook.png"/>-->
    </div>
    <!--    </div>-->
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.2/gsap.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.2/ScrollTrigger.min.js"></script>

<script>
gsap.registerPlugin(ScrollTrigger);
/*gsap.to('.section__about', {

    x: 100,
    rotation: 180,
    duration: 1
});*/
const tl = gsap.timeline();
const endWidth = document.querySelector('.end').offsetWidth;

var li = document.getElementsByClassName('about__item');
var summ = 0;
for (var i = 0; i < li.length; i++) {
    summ += li[i].offsetWidth;
}
console.log('Total:' + summ);

tl.to('.end', {x: -summ + 150, duration: 30, delay: 1});
//tl.to('.about__blocks', {x: -2000, duration: 30, delay: 1});

let section__about = gsap.utils.toArray('.section__about');
ScrollTrigger.create({
    xPercent: -100,
    ease: 'elastic',
    animation: tl,
    trigger: '.section__about',
    start: 'top top',
    end: '+=3000',
    scrub: true,
    markers: false,
    pin: true
});

</script>
<script>
import Navbar from '@/views/landing/Navbar'
import '@/assets/style/grid.scss'

export default {
    name: 'aboutProject',
    components: {Navbar}
}
</script>

<style scoped>
.aboutContent {
    box-sizing: border-box;
    width: 100%;
    max-width: 1400px;
    padding: 0 50px 0 80px;
    position: relative;
    height: auto;
}

.aboutContent .AboutImgDisplayNone {
    display: none;
}

.AboutProject {
    margin-top: 3%;
    display: inline-block;
    width: 60%;
    box-sizing: border-box;
}

.AboutProject h3 {
    font-style: normal;
    font-weight: 800;
    font-size: 27px;
    line-height: 150%;
    display: flex;
    align-items: center;
    color: #212353;
    margin-bottom: 30px;
}

.AboutProject p {
    font-style: normal;
    font-weight: 300;
    font-size: 21px;
    line-height: 160%;
    color: #4B5D68;
}

.aboutContent .Img {
    box-sizing: border-box;
    display: inline-block;
    float: right;
    width: 40%;
    padding-left: 5%;
}

.aboutContent .aboutComponentsCopyBookImg {
    margin-top: 50px;
    margin-left: -80px;
}

.txt-title-ap{
    font-size: 48px;
    margin-bottom: 8px;
}

@media (max-width: 992px) {
    .AboutProject {
        margin-top: 0;
    }

    .aboutContent .Img {
        margin-top: 10%;
    }
}

@media (max-width: 700px) {
    .aboutContent {
        position: relative;
        width: auto;
        height: auto;
    }

    .aboutContent .AboutImgDisplayNone {
        box-sizing: border-box;
        display: block;
        width: 80%;
        padding: 5%;
    }

    .AboutProject {
        display: inline-block;
        width: 100%;
    }

    .aboutContent .Img {
        display: none;
    }
}

@media (max-width: 420px) {
    .txt-title-ap{
        font-size: 32px;
        margin-bottom: 8px;
    }
    .aboutContent {
        padding: 5%;
        position: relative;
        width: 100%;
        height: auto;
    }

    .aboutContent .AboutImgDisplayNone {
        display: block;
        width: 90%;
    }

    .AboutProject {
        display: inline-block;
        width: 100%;
        padding: 2%;
    }

    .content .Img {
        display: none;
    }
}
</style>
